var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16675 0.041687H2.54175C1.16104 0.041687 0.041748 1.16098 0.041748 2.54169V17.4584C0.041748 18.8391 1.16104 19.9584 2.54175 19.9584H4.16675H17.4584C18.8391 19.9584 19.9584 18.8391 19.9584 17.4584V16V12.6667V9.33335V6.00002V2.54169C19.9584 1.16098 18.8391 0.041687 17.4584 0.041687H4.16675ZM18.7084 15.375V13.2917H4.95842C4.9007 13.2917 4.84481 13.2839 4.79175 13.2692V15.3975C4.82214 15.3891 4.85346 15.3829 4.88553 15.3792L4.95842 15.375H18.7084ZM4.79175 16.6026C4.84481 16.6172 4.9007 16.625 4.95842 16.625H18.7084V17.4584C18.7084 18.1487 18.1488 18.7084 17.4584 18.7084H4.79175V16.6026ZM18.7084 9.95835V12.0417H4.95842L4.88553 12.0459C4.85346 12.0496 4.82214 12.0558 4.79175 12.0642V9.93588C4.84481 9.95053 4.9007 9.95835 4.95842 9.95835H18.7084ZM18.7084 8.70835V6.62502H4.95842C4.9007 6.62502 4.84481 6.6172 4.79175 6.60255V8.73082C4.82214 8.72243 4.85346 8.71628 4.88553 8.71256L4.95842 8.70835H18.7084ZM18.7084 2.54169V5.37502H4.95842L4.88553 5.37923C4.85346 5.38295 4.82214 5.3891 4.79175 5.39749V1.29169H17.4584C18.1488 1.29169 18.7084 1.85133 18.7084 2.54169ZM3.54175 1.29169H2.54175C1.85139 1.29169 1.29175 1.85133 1.29175 2.54169V17.4584C1.29175 18.1487 1.85139 18.7084 2.54175 18.7084H3.54175V1.29169Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group-4.2956cb51ebac13d3d5ee77edb0f84a4e.svg";
export { ForwardRef as ReactComponent };